import React from 'react';
// import Head from 'next/head';

export default function Meta({
  title = 'Making Powerful Connections'
}: {
  title?: string;
}) {
  return (
    // <Head>
    //   <title>{`${title} | Line Drive`}</title>
    //   <meta name="viewport" content="initial-scale=1.0, width=device-width" />
    //   <link rel="icon" type="image/x-icon" href="/favicon.svg" />
    // </Head>
    null
  );
}
